import $ from 'jquery';
import 'magnific-popup';
import './Language/magnific-popup'


$(document).ready(function() {

    var $iframe = $("<iframe/>")
        .attr("src", "https://www.ausschreiben.de/katalog/nis_nordic_industrials_service/custom")
        .css({
            width: "100%",
            height: "600px",
            position: "relative",
            border: "none"
        });

        // $("<div/>").append($iframe).dialog({
        //     autoOpen: true,
        //     title: "Ausschreibungstexte",
        //     width: "80%",
        //     height: $(window).innerHeight() * 0.8,
        //     modal: true,
        //     buttons: {
        //         "Schließen": function() {
        //             $(this).dialog("close");
        //         }
        //     }
        // });


    if($('[href*=tender]').length > 0) {
        $('[href*=tender]').magnificPopup({
            type: 'iframe',
            iframe: {
                markup: $iframe
            }
        });
    }





});

